"react";
import { Form } from "react-bootstrap";

export const Select = ({
  label,
  field,
  register,
  options = [],
  defaultValue = "",
  errors,
}) => {
  return (
    <Form.Group className="mb-3">
      <Form.Label>{label}</Form.Label>
      <Form.Select {...register(field)} isInvalid={!!errors[field]}>
        <option value={defaultValue} defaultValue key={defaultValue}>
          {defaultValue}
        </option>
        {options.map((option, index) => (
          <option key={`${option.value}-${index}`} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>
      {errors[field] && (
        <Form.Control.Feedback type="invalid">
          {errors[field]?.message}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};
